import "./App.css";
import "./components/AppleStore/Iphone/iphoneStyle.css";

import { Outlet } from "react-router-dom";
import ScrollToTop from "./resuable/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
}

export default App;
